import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { styles } from "./FilterNSearchBar.styles";

export const FilterBarSearch = ({ searchQuery, onSearchChange }) => (
  <TextField
    size="small"
    placeholder="Search..."
    value={searchQuery}
    onChange={onSearchChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ color: "#6B7280", fontSize: 20 }} />
        </InputAdornment>
      ),
      endAdornment: searchQuery && (
        <InputAdornment position="end">
          <IconButton
            size="small"
            onClick={() => onSearchChange({ target: { value: "" } })}
          >
            {" "}
            <ClearIcon fontSize="small" />{" "}
          </IconButton>
        </InputAdornment>
      ),
    }}
    sx={{ ...styles.searchField, width: "100%" }}
  />
);
